import React, { useCallback, useRef, useState } from 'react';
import { GlobalStyle } from '../../styles/global';
import logoImg from '../../assets/metodo-billings-marca-dashboard.png';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from '../../components/Elements/Input';
import Button from '../../components/Elements/Button';
import { Container, Aviso } from '../SignIn/styles';
import getValidationErros from '../../utils/getValidationErros';

import toast from 'react-hot-toast';
import {api} from '../../services/api';

interface ForgotPasswordFormData{
    email: string;
}

const ForgotPassword: React.FC = () => {
    const [load, setLoad] = useState(false)
    const formRef = useRef<FormHandles>(null);
    
    const handleForgot = useCallback(async (data: ForgotPasswordFormData) => {
        try {
            setLoad(true);
            formRef.current?.setErrors({});
            const schema = Yup.object().shape({
                email: Yup.string().required('Email obrigatório').email('Insira um email válido'),
            });
            await schema.validate(data, { abortEarly: false, });

            await api.post('reset_pass.php', data)
            toast.success('VERIFIQUE SEU EMAIL, INCLUINDO CAIXA DE SPAM');
            

        } catch (err) {
            if(err instanceof Yup.ValidationError){
                const errors = getValidationErros(err);
                formRef.current?.setErrors(errors);
                return;
            }
            //const resp = err.response.statusText;            
            toast.error('ERRO, AO TENTAR RECUPERAR');
        } finally {
            setLoad(false);
        }
    }, []);

   
    return ( 
    <>
        <Container>
            <img src={logoImg} alt="Método Billings" />
            <br />
            <h3>RECUPERAR SENHA</h3>
            <Aviso>
            DIGITE SEU EMAIL ABAIXO PARA RECEBER UM 
            LINK DIRETO NA SUA CAIXA DE CORREIO E REALIZAR A TROCA DA SENHA
            </Aviso>
            <Form ref={formRef} onSubmit={handleForgot}>

                <Input type="text" name="email" placeholder="SEU EMAIL" />
                <Button loading={load} type="submit">RECUPERAR</Button>                
            
                <div className="outros">
                    <Link to="/cadastro" className="botao">Fazer cadastro</Link>
                    <a href="/" className="botao">Já tenho cadastro</a>
                </div>
            </Form>
        </Container>
        <GlobalStyle />
    </>
    );
}

export default ForgotPassword;